import React, { Component } from 'react';
import ReactGA from 'react-ga';
import titleBox from './image/aboutMe/abt_esky_titlebox.jpg';
import staffCard from './image/aboutMe/esky_staffcard.png';
import life1 from './image/aboutMe/esky_life1.png';
import life2 from './image/aboutMe/esky_life2.png';
import life3 from './image/aboutMe/esky_life3.png';
import esky from './video/Esky.mp4';

class AboutMe extends Component {
	componentWillMount() {
		ReactGA.set({
			'dimension1': ':mini:fashionweekfw17',
			'dimension2': ':mini',
			'dimension3': ':mini:fashionweekfw17',
			'dimension4': ':mini:fashionweekfw17:aboutMe'
		});
		ReactGA.pageview('/#aboutMe');
	}
	render() {
		return (
			<div className="aboutMe">
				<div className="sub-page-header">
					<div className="sub-page-title">
						<div>
							<img alt="About ESKY" src={titleBox} />
						</div>
					</div>
				</div>
				<div className="sub-page-content">
					<div id="scrollable-area" className="scrollable-area">
						<img className="staffCard" alt="Staff Card" src={staffCard} />
						<div className="video">
							<video controls autoPlay>
								<source src={esky} type="video/mp4" />
								Your browser does not support HTML5 video.
							</video>
						</div>
						<div className="desc">Mr.Esky正是《Esquire》雜誌由1934年至今的代表人物兼吉祥物,<br />每逄大時大節總會走出來熱鬧一番</div>
						<div className="photos">
							<div className="photo">
								<img alt="" src={life1} />
							</div>
							<div className="photo">
								<img alt="" src={life2} />
							</div>
							<div className="photo">
								<img alt="" src={life3} />
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default AboutMe;



// WEBPACK FOOTER //
// ./src/AboutMe.js